import React from 'react';
import './WhyAttend.css';

const WhyAttend = () => {
  return (
    <section id="why-attend" className="why-attend">
      <div className="container">
        <div className="why-attend-content">
          <div className="why-attend-visual">
            <div className="visual-placeholder">
              <div className="network-animation">
                <div className="person-node"></div>
                <div className="person-node"></div>
                <div className="person-node"></div>
                <div className="connection-line"></div>
                <div className="connection-line"></div>
                <div className="connection-line"></div>
                <div className="collaboration-spark"></div>
              </div>
              <p>Founders Connecting & Collaborating</p>
            </div>
          </div>
          <div className="why-attend-text">
            <h2>The Builder's Movement</h2>
            <p className="movement-intro">
              The tech ecosystem in this region is growing fast, yet there's a noticeable gap — a lack of cohesive founder culture and community-driven collaboration.
            </p>
            <p>
              iBUILD seeks to close that gap by creating an intentional platform where the next generation of founders can learn, network, and get inspired to build companies that last. This event is not just about conversations; it's about building a movement.
            </p>
            <div className="movement-values">
              <div className="value-item">
                <span className="value-icon">💪</span>
                <span>Grit & Determination</span>
              </div>
              <div className="value-item">
                <span className="value-icon">🤝</span>
                <span>Collaboration</span>
              </div>
              <div className="value-item">
                <span className="value-icon">📈</span>
                <span>Growth Mindset</span>
              </div>
            </div>
            <a 
              href="https://luma.com/btcyyph6" 
              target="_blank" 
              rel="noopener noreferrer"
              className="btn btn-primary"
            >
              🔗 Join the Movement
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyAttend;
